'use strict';
const moment = require('moment');
const _ = require('lodash');
const DATE_FORMAT = /^\d{4}-\d{2}-\d{2}$/;
module.exports = function (birth, death) {
  if (_.isNil(birth)) {
    return;
  }

  if (!_.isString(birth)) {
    return;
  }

  if (!_.isNil(death) && !_.isString(death)) {
    return;
  }

  if (!DATE_FORMAT.test(birth)) {
    return;
  }

  if (!_.isNil(death) && !DATE_FORMAT.test(death)) {
    return;
  }

  const end = _.isNil(death) ? moment() : moment(death, 'YYYY-MM-DD');

  return end.diff(moment(birth, 'YYYY-MM-DD'), 'years');
};
